// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PriceSelector {
    width: 148px;
    padding: 3px;
    font-size: 11px;
    border-radius: 5px;
    outline: none;
    border: 1px solid var(--PriceSelectorBorder);
    background-color: var(--filterColorElse);
    color: gray;
    cursor: pointer;
}

.PriceSelector option {
    background-color: var(--PriceSelectorOptionsBackground);
    color: var(--PriceSelectorSelectColor);
    border-radius: 5px;
    outline: none;
}

.PriceSelector option:checked,
option:hover {
    background-color: var(--PriceSelectorSelectColor);
    color: white;
    border-radius: 5px;
    outline: none;
}

.PriceSelector option:focus {
    background-color: var(--PriceSelectorSelectColor);
    color: white;
    border-radius: 5px;
    outline: none;
}

.PriceSelectorClassIsGray {
    width: 148px;
    padding: 6px;
    font-size: 11px;
    border-radius: 5px;
    outline: none;
    border: 1px solid var(--PriceSelectorBorder);
    background-color: var(--PriceSelectorBackground);
    color: white;
    opacity: 0.3;
    pointer-events: none;
}

.PriceSelectorClassIsGray option {
    display: none;
}

@media only screen and (max-width: 320px) {
    .PriceSelector {
        transform: scale(0.8);
    }

    .PriceSelectorClassIsGray {
        transform: scale(0.8);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/PriceSelector/PriceSelector.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,4CAA4C;IAC5C,wCAAwC;IACxC,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uDAAuD;IACvD,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,iDAAiD;IACjD,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iDAAiD;IACjD,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,4CAA4C;IAC5C,gDAAgD;IAChD,YAAY;IACZ,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;AACJ","sourcesContent":[".PriceSelector {\n    width: 148px;\n    padding: 3px;\n    font-size: 11px;\n    border-radius: 5px;\n    outline: none;\n    border: 1px solid var(--PriceSelectorBorder);\n    background-color: var(--filterColorElse);\n    color: gray;\n    cursor: pointer;\n}\n\n.PriceSelector option {\n    background-color: var(--PriceSelectorOptionsBackground);\n    color: var(--PriceSelectorSelectColor);\n    border-radius: 5px;\n    outline: none;\n}\n\n.PriceSelector option:checked,\noption:hover {\n    background-color: var(--PriceSelectorSelectColor);\n    color: white;\n    border-radius: 5px;\n    outline: none;\n}\n\n.PriceSelector option:focus {\n    background-color: var(--PriceSelectorSelectColor);\n    color: white;\n    border-radius: 5px;\n    outline: none;\n}\n\n.PriceSelectorClassIsGray {\n    width: 148px;\n    padding: 6px;\n    font-size: 11px;\n    border-radius: 5px;\n    outline: none;\n    border: 1px solid var(--PriceSelectorBorder);\n    background-color: var(--PriceSelectorBackground);\n    color: white;\n    opacity: 0.3;\n    pointer-events: none;\n}\n\n.PriceSelectorClassIsGray option {\n    display: none;\n}\n\n@media only screen and (max-width: 320px) {\n    .PriceSelector {\n        transform: scale(0.8);\n    }\n\n    .PriceSelectorClassIsGray {\n        transform: scale(0.8);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
